import { useEffect, useRef } from 'preact/hooks'
import { useSearchspringContext } from '../fetchers/provider'
import { useIntersectionObserver } from '../hooks/useIntersectionObserver'
import { usePageTracker } from '../hooks/usePageTracker'
import clsx from 'clsx'

export function InfiniteScrollNext() {
  const { results, refine, isLoading } = useSearchspringContext()
  const { loadedPages } = usePageTracker()
  const totalPages = results?.pagination?.totalPages ?? 1
  const { setNode, entry } = useIntersectionObserver({
    rootMargin: '300px',
    threshold: 0.1
  })

  useEffect(() => {
    if (isLoading) return
    if (entry?.isIntersecting) {
      handleNextPage()
    }
  }, [entry])

  const handleNextPage = () => {
    const nextPage = loadedPages[loadedPages.length - 1] + 1
    if (nextPage > totalPages) return
    refine('page', nextPage)
  }

  // Hide load more if all pages are loaded
  if (loadedPages[loadedPages.length - 1] >= totalPages) return null
  return (
    <div className="flex gap-x-5">
      <button ref={setNode} className="btn btn-md btn-solid-black" onClick={handleNextPage}>
        <span>Load More</span>
      </button>
    </div>
  )
}

export function InfiniteScrollPrevious({ className }) {
  const { refine, isLoading } = useSearchspringContext()
  const { loadedPages } = usePageTracker()
  const hasBeenClicked = useRef(false)
  const { setNode, entry } = useIntersectionObserver({
    rootMargin: '100px',
    threshold: 1
  })

  useEffect(() => {
    if (!hasBeenClicked.current) return
    if (isLoading) return
    if (entry?.isIntersecting) {
      handlePrevPage()
    }
  }, [entry])

  const handleClick = () => {
    hasBeenClicked.current = true
    handlePrevPage()
  }

  // Handle previous page based on array of loaded pages
  const handlePrevPage = () => loadedPages.length && loadedPages[0] !== 1 && refine('page', loadedPages[0] - 1)

  // Hide load previous if first page is loaded
  if (!loadedPages.length || loadedPages[0] === 1) return null
  return (
    <div className={clsx('flex basis-full justify-center gap-x-5 py-4', className)}>
      <button ref={setNode} className="btn btn-md btn-solid-black" onClick={handleClick}>
        <span>Load Previous</span>
      </button>
    </div>
  )
}
